import { render, staticRenderFns } from "./TaskThread.vue?vue&type=template&id=1332df96&"
import script from "./TaskThread.vue?vue&type=script&lang=ts&"
export * from "./TaskThread.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports